var _path, _path2, _path3, _circle, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg13506714241581665198(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41.6 39.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#616E7D",
    d: "M21.8 32.3c0 .4-.2.8-.6 1v.1h2.9c1.3 0 2.4-1.1 2.3-2.5-.1-1.2-1-2.1-2.2-2.2-1.3-.1-2.5 1-2.5 2.3v1.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#AAD3C7",
    d: "M27.6 11.6v.1l3.1-2.8v-.2l-3.1-3v.1zM32.8 9.7c-.2.2-.4.2-.6.2-.2 0-.4-.1-.6-.2L31 9l-3 2.8h8.6l-3-2.8-.8.7zM33.8 8.9l3.1 2.8V5.7l-3.1 3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#AAD3C7",
    d: "M27.7 5.5l3.2 3.1.2.2.8.7v.1h.1l.1.1H32.4l.1-.1h.1v-.1l.8-.7.1-.2 3.2-3.1v-.1h-8.9z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#616E7D",
    cx: 11.6,
    cy: 13.4,
    r: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#616E7D",
    d: "M21 19.7l-.5-.9.5.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#AAD3C7",
    d: "M11.2 19.7l-.5 3h1.9l-.5-3 .5-.9h-1.9l.5.9z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#616E7D",
    d: "M32.2 16.5c4.3 0 7.9-3.5 7.9-7.9 0-4.3-3.5-7.9-7.9-7.9-4.3 0-7.9 3.5-7.9 7.9 0 .6.1 1.1.2 1.7L21 11.6c-1.6-3.5-5.2-6-9.3-6C6 5.6 1.3 10.2 1.3 15.8c0 5.7 4.6 10.3 10.3 10.3 1.7 0 3.4-.4 4.8-1.2l2.7 3c-1.2 1.3-1.7 3-1.5 4.7.3 2.9 2.6 5.1 5.4 5.4h.6c1.7 0 3.4-.7 4.5-2 1.2-1.3 1.7-3 1.5-4.7-.3-2.9-2.6-5.1-5.4-5.4-1.4-.1-2.8.2-3.9 1L17.7 24c2.6-1.9 4.2-4.9 4.2-8.3 0-1-.2-2-.4-2.9l3.5-1.2c1.2 2.9 4 4.9 7.2 4.9zm0-14.3c3.5 0 6.4 2.9 6.4 6.4 0 3.5-2.9 6.4-6.4 6.4-3.5 0-6.4-2.9-6.4-6.4.1-3.5 2.9-6.4 6.4-6.4zm-7.8 32.5l.4.4-1 1.1-1-1.1.4-.4-.7-.6c-.1-.1.4-.4.4-.4l.9 2.6.9-2.6s.5.3.4.4l-.7.6zm-1.1-.4h1.1l-.6 1.7-.5-1.7zm.3-6.8h.5c2.2.2 3.9 1.9 4.1 4.1.1 1.2-.2 2.4-1 3.3-.3-.8-1.1-1.4-2-1.4h-2.7c-1.1 0-2 .8-2.1 1.8-.7-.7-1.2-1.7-1.3-2.8-.1-1.3.3-2.6 1.2-3.5.8-1 2-1.5 3.3-1.5zm-10.5-4.8H10l-.9-4.6h4.8l-.8 4.6zm4.6-.7v-.5c0-2.1-1.7-3.8-3.8-3.8H9.3c-2.1 0-3.8 1.7-3.8 3.8v.5c-1.6-1.6-2.6-3.8-2.6-6.2 0-4.8 3.9-8.7 8.7-8.7 4.8 0 8.7 3.9 8.7 8.7 0 2.5-1 4.6-2.6 6.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg13506714241581665198);
export default __webpack_public_path__ + "static/media/13506714241581665198.f01d7601b1dd25205d460bbefe69e4ad.svg";
export { ForwardRef as ReactComponent };